import { Box, Button, Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import "./Main.css";
import Logo from "../../assets/logo_quick-learning-tool.png";
import Intro from "./components/intro/Intro";
import Map from "./components/map/Map";
import Play from "../../assets/play.png";
import { Replay } from "@mui/icons-material";
import { useSelector, useDispatch } from "react-redux";
import {
  setPageState,
  setPercent,
  setLanguage,
} from "./components/features/ChatSlice";
import Play_Icon from "../../assets/new/play_icon.png";
import Pause_Icon from "../../assets/new/pause_icon.png";
import InsEN from "./components/instructions/EN";
import InsPH from "./components/instructions/PH";
import { Navigate, useNavigate } from "react-router-dom";

function Main() {
  const [page, setPage] = useState(0);
  const [start, setStart] = useState(false);
  const [pageLang, setPageLang] = useState("");
  const percent = useSelector((state) => state.chat.percent);
  const pageState = useSelector((state) => state.chat.pageState);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleClick = () => {
    if (percent >= 100) {
      setPage(1);
    }
  };

  const handleRestart = () => {
    setPage(0);
    dispatch(setPercent(0));
    dispatch(setPageState("start"));
    setStart(false);
  };

  const handleLink = () => {
    window.location.href = "https://www.aralplus.ph/quick-learning-tools";
  };

  useEffect(() => {
    if (window.location.pathname === "/en") {
      setPageLang("en");
    } else {
      setPageLang("ph");
    }
  }, []);

  const handleStart = (lang) => {
    console.log(lang);
    dispatch(setLanguage(lang));
    setTimeout(() => {
      setStart(true);
    }, 1000);
  };

  return (
    <Box>
      <Grid container>
        <Grid item xs={12} md={4}>
          <Box className="left-card">
            <Box className="left-container">
              <Box className="img-container">
                <img src={Logo} alt="logo" className="image" />
              </Box>
              <Box className="instruction-container">
                {pageLang === "en" ? <InsEN /> : <InsPH />}
              </Box>
              <Box className="button-container">
                {pageState === "finish" ? (
                  <>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <Button
                        className="left-button"
                        startIcon={<Replay />}
                        onClick={handleRestart}
                      >
                        Restart
                      </Button>
                      <Box
                        sx={{
                          marginTop: "1rem",
                          color: "#0ebeef",
                          fontSize: "1.15rem",
                          fontWeight: "700",
                          cursor: "pointer",
                        }}
                        onClick={() => handleLink()}
                      >
                        Back to Quick Learning Tools
                      </Box>
                    </Box>
                  </>
                ) : (
                  <>
                    {pageState === "start" && start === false && (
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignContent: "center",
                        }}
                      >
                        <Button
                          className="left-button"
                          onClick={() => {
                            handleStart("ENG");
                            setPageLang("en");
                            navigate("/en");
                          }}
                        >
                          <img
                            src={Play}
                            alt="Start"
                            style={{ marginRight: "11px", width: "1rem" }}
                          />
                          Start (English)
                        </Button>
                        <Button
                          className="left-button"
                          onClick={() => {
                            setPageLang("ph");
                            navigate("/ph");
                            handleStart("FIL");
                          }}
                          sx={{ marginBottom: "1rem" }}
                        >
                          <img
                            src={Play}
                            alt="Start"
                            style={{ marginRight: "11px", width: "1rem" }}
                          />
                          Start (Filipino)
                        </Button>
                      </Box>
                    )}
                  </>
                )}
              </Box>
            </Box>
          </Box>
        </Grid>
        <Grid item xs={12} md={8}>
          <Box className="right-card">
            {page === 1 ? (
              <Map />
            ) : (
              <Intro start={start} handleCLick={handleClick} />
            )}
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}

export default Main;
